import { Button } from '@sr/ui-library';
import { Link } from 'react-router-dom';

/** Shared with the gated View, so gated and ungated cards line up. */
export const VIEW_BUTTON_PROPS = {
  className: 'w-full sm:w-auto',
  size: 'sm',
  variant: 'outline',
} as const;

type EntityCardViewActionProps = {
  viewUrl?: string;
};

export const EntityCardViewAction = ({
  viewUrl,
}: EntityCardViewActionProps) => {
  return (
    <Button asChild={!!viewUrl} {...VIEW_BUTTON_PROPS} disabled={!viewUrl}>
      {viewUrl ? (
        <Link className="!no-underline" to={viewUrl}>
          View
        </Link>
      ) : (
        'View'
      )}
    </Button>
  );
};
